export default {
      id: "retirement-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#retirement",
      toString: function () {
        return this.url;
      }
    }